module.exports = "/images/accordion-plus.svg?638545b0ec5920c2210496fe73e64895";